import { getElement, getElements } from '../util';

/**
 * Manage formset rows
 */
export class AddFormsetRow {
    // Button references
    private readonly addbtn: HTMLButtonElement;
    private readonly delbtn: HTMLButtonElement;

    // Table reference
    private readonly table: HTMLTableElement;
    private readonly emptyrow: HTMLTableRowElement;

    // Formset settings
    private maxforms: Element;
    private minforms: Element;
    private totalforms: Element;
    private initialforms: Element;


    constructor(addbtn: HTMLButtonElement, delbtn: HTMLButtonElement, table: HTMLTableElement) {
        console.log("AddFormsetRow constructor: " + addbtn + delbtn)
        // Set element references
        this.addbtn = addbtn
        this.delbtn = delbtn

        this.table = table

        let emptyrow = table.getElementsByClassName("empty-form")
        if (emptyrow.length == 1) {
            this.emptyrow = emptyrow[0]
        } else {
            console.log("Unable to locate .empty-form")
        }

        // Get the formset settings from HTML
        this.totalforms = this.getFormsetConfig("-TOTAL_FORMS");
        this.initialforms = this.getFormsetConfig("-INITIAL_FORMS");
        this.maxforms = this.getFormsetConfig("-MAX_NUM_FORMS");
        this.minforms = this.getFormsetConfig("-MIN_NUM_FORMS");


        // Add listeners
        this.addbtn.addEventListener("click", e => this.handleAddClick(e));
        this.delbtn.addEventListener("click", e => this.handleDelClick(e));
    }

    private getFormsetConfig(name: string): Element {
        // The settings are stored in the document as hidden inputs
        // Search the document for the input string and return the value
        let qs = document.querySelectorAll("[id$=" + name + "]")

        // If we have only one result, return the value - otherwise set to zero
        if (qs.length == 1) {
            return qs.item(0)
            // return (parseInt(qs.item(0).value));
        } else {
            return null;
        }
    }

    private setFormsetConfig(name: string, val: number) {
        return 0;
    }

    private findAndReplaceNodeData(nodes: NodeList, find: string, replace: string): void {
        // Update this node
        if (nodes.name) {
            nodes.name = nodes.name.replace(find, replace);
        }
        if (nodes.id) {
            nodes.id = nodes.id.replace(find, replace);
        }

        // If the node has children, recurse into them and update
        if (nodes.childNodes.length > 0) {
            nodes.childNodes.forEach(element => {
                this.findAndReplaceNodeData(element, find, replace)
            });
        }
    }


    public handleAddClick(e: Event): void {
        console.log("Add button clicked")

        if (this.totalforms.value < this.maxforms.value) {
            console.log("We can add a form...")
            // Copy the template row
            let newrow = this.emptyrow.cloneNode(true);

            // Adjust template values to create new row
            newrow.attributes.removeNamedItem("class");
            newrow.childNodes.forEach(node => {
                this.findAndReplaceNodeData(node, "__prefix__", (this.totalforms.value));
            });
            this.totalforms.value++;

            // Todo - update values from API

            this.table.lastElementChild?.append(newrow)

        } else {
            console.log("Reached max_forms! Max = " + this.maxforms.value + " Total = " + this.totalforms.value)
        }

    }

    public handleDelClick(e: Event): void {
        console.log("Del button clicked")
        if (this.totalforms.value > this.minforms.value) {
            console.log("There are " + this.totalforms.value + " and the minimum is " + this.minforms.value);
            this.table.lastElementChild?.lastElementChild?.remove();
            this.totalforms.value--;
        }

    }
}

export function initAddFormsetRow(): void {
    let addrow_table: NodeList = document.querySelectorAll("[id$=_addrow_table]")
    if (addrow_table.length > 0) {
        // TODO: Expand to handle multiple addrow tables
        new AddFormsetRow(getElement<HTMLButtonElement>('add_meter_row'), getElement<HTMLButtonElement>('del_meter_row'), addrow_table[0]);
    };
}